import { FILES_PRE_SIGNED, FILES_PRE_SIGNED_QUESTIONNAIRE, FILES_UPLOADED } from 'constants/requestUrls';
import mainApi from 'store/apis/mainApi';

import type IBaseQueryResponse from 'store/types/IBaseQueryResponse';
import type IConfirmFileUploadedRequest from '../interfaces/IConfirmFileUploadedRequest';
import type IFile from '../interfaces/IFile';
import type IPresignedFileRequest from '../interfaces/IPresignedFileRequest';
import type { IQuestionnairePresignedFileRequest } from '../interfaces/IPresignedFileRequest';
import type { IPresignedData } from '../interfaces/IPresignedFileResponse';

const filesApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getPresignedPost: builder.mutation<IBaseQueryResponse<IPresignedData>, IPresignedFileRequest>({
      query: (data) => ({
        url: FILES_PRE_SIGNED,
        method: 'POST',
        body: data,
      }),
    }),
    getQuestionnairePresignedPost: builder.mutation<
    IBaseQueryResponse<IPresignedData>,
    IQuestionnairePresignedFileRequest
    >({
      query: (data) => ({
        url: FILES_PRE_SIGNED_QUESTIONNAIRE,
        method: 'POST',
        body: data,
      }),
    }),
    confirmFileUploaded: builder.mutation<IBaseQueryResponse<IFile>, IConfirmFileUploadedRequest>({
      query: ({ id, companyId }) => ({
        url: FILES_UPLOADED.replace('{id}', `${id}`),
        method: 'POST',
        ...(companyId !== undefined && { params: { companyId } }),
      }),
    }),
  }),
});

export const {
  useGetPresignedPostMutation,
  useGetQuestionnairePresignedPostMutation,
  useConfirmFileUploadedMutation,
} = filesApi;

export default filesApi;
